<template>
  <div>
    <status-bar :status="status + ''"></status-bar>
    <div class="row-bg" :class="{'margin-bottom1':isShowWorkType}">
      <div class="row row1">
        <p class="r-province" :class="workProvince == '工作地-省份' ? '' : 'txt-color'" @click="provincePickerClick">{{
      workProvince }}
        </p>
        <p class="r-city" :class="workCity == '工作地-城市' ? '' : 'txt-color'" @click="cityPickerClick">{{ workCity }}</p>
      </div>
      <div class="row">
        <p :class="msgFrom.value == '招募信息来源' ? '' : 'txt-color'" @click="fromPickerClick">{{ msgFrom.value }}</p>
      </div>
      <div v-if="msgFrom.value == '司机推荐' && workType != '轻享司机'" class="row">
        <input type="text" maxlength="10" placeholder="请输入邀请码（如有）" v-model="inviteCode" @blur="inputBlurEvent">
      </div>
      <div class="row">
        <input type="tel" maxlength="11" placeholder="紧急联系人手机" v-model="contactPhone" @blur="inputBlurEvent">
      </div>

      <template v-if="isShowWorkType">
        <div class="join-title-bg">
          <p>选择加盟司机类型</p>
          <div @click="showRules=true">
            <img :src="require(`../../assets/comshape.png`)" alt="" srcset="">
            <span>查看报名须知</span>
          </div>
        </div>
        <div class="join-table-bg">
          <table class="comparison-table">
            <tr><td>权益对比</td>
              <td :class="{'selected':workTypeId==1}" @click="() => { handlePickerConfirm4(1, '精选司机') }">
                <div class="join-select-bg"><img class="join-select-img" :src="require(`@/assets/${workTypeId==1?'':'un_'}choose.png`)" alt="" srcset="">加盟精选司机</div>
              </td>
              <td :class="{'selected':workTypeId==4}" @click="() => { handlePickerConfirm4(4, '轻享司机') }">
                <div class="join-select-bg"><img class="join-select-img" :src="require(`@/assets/${workTypeId==4?'':'un_'}choose.png`)" alt="" srcset="">加盟轻享司机</div>
              </td></tr>
            <tr><td><p>订单业务</p><p>接听类型</p></td><td :class="{'selected':workTypeId==1}" ><p>全业务接听</p><p>（含车后）</p></td><td :class="{'selected':workTypeId==4}" ><p>部分酒驾业务</p><p>（不含车后）</p></td></tr>
            <tr><td>抢单资格</td><td :class="{'selected':workTypeId==1}" >全业务可抢</td><td :class="{'selected':workTypeId==4}" >酒后代驾业务</td></tr>
            <tr><td><p>特惠/特价</p><p>设置</p></td><td :class="{'selected':workTypeId==1}" > <p>可自由设置</p><p>开/关</p></td><td :class="{'selected':workTypeId==4}" ><p>强制接听</p><p>不可设置</p></td> </tr>
            <tr><td><p>垫付资格</p></td> <td :class="{'selected':workTypeId==1}" ><p>开通垫付</p><p>服务后享有</p></td><td :class="{'selected':workTypeId==4}" ><p>不垫付</p></td></tr>
            <tr><td><p>形象抽查</p><p>管控</p></td><td :class="{'selected':workTypeId==1}" ><p>管控</p></td><td :class="{'selected':workTypeId==4}" ><p>不管控</p></td></tr>
            <tr><td><p>活力值</p><p>加分</p></td><td :class="{'selected':workTypeId==1}" ><p>同等加分</p></td><td :class="{'selected':workTypeId==4}" ><p>同等加分</p></td></tr>
            <tr><td><p>驾龄要求</p></td><td :class="{'selected':workTypeId==1}" ><p>满3年</p></td><td :class="{'selected':workTypeId==4}" ><p>满1年</p></td></tr>
          </table>
        </div>
      </template>
    </div>

    <div class="join-driver-next-btn" v-if="isShowWorkType">
      <p class="detail detail-margin-bottom">找不到的某个城市表示该城市暂未开通代驾服务</p>
      <p class="next-btn next-btn-margin" :class="complete"  @click="showConfirmBox">下一步</p>
    </div>

    <template v-if="!isShowWorkType">
      <p class="next-btn" :class="complete" @click="showConfirmBox">下一步</p>
      <p class="detail detail-margin">找不到的某个城市表示该城市暂未开通代驾服务</p>
      <div class="tips">
        {{ defaultInfo.default_text }}<span>{{ defaultInfo.default }}</span>
      </div>
      <div class="notes">
        <p>报名须知</p>
        <ul>
          <li>报名信息必须真实有效，且满足近3年安全驾驶无事故；</li>
          <li>报名人员年龄需满足23-55周岁，身体健康；</li>
          <li>确认自愿使用平台信息服务；</li>
          <li>确认有以下证件：身份证、驾驶证；</li>
          <li>根据城市不同，确认同意在成功签约后从信息费账户扣缴报名注册费；</li>
          <li>当终止提供信息服务时，处理周期为90天；</li>
        </ul>
      </div>
    </template>

    <div class="confirm" :class="showConfirm ? 'show' : 'hide'">
      <div class="c-bg">
        <div class="c-title">
          <p>请确认所录入信息正确</p>
        </div>
        <div class="c-content">
          <p>工作地：{{ workProvince + " " + workCity }}</p>
          <p>招募信息来源：{{ msgFrom.value }}</p>
          <p>紧急联系人手机：{{ contactPhone }}</p>
        </div>
        <div class="c-bottom">
          <p class="c-cancel" @click="cancelBtnAction">返回修改</p>
          <p class="c-sure" @click="sureBtnAction">确认提交</p>
        </div>
      </div>
    </div>

    <awesome-picker ref="picker1" :data="picker.data1" :textTitle="picker.textTitle1" :textConfirm="picker.textConfirm"
      :textCancel="picker.textCancel" @cancel="handlePickerCancel" @confirm="handlePickerConfirm1"></awesome-picker>
    <awesome-picker v-for="item in options" :key="item.num" ref="picker2" :data="picker.data2"
      :textTitle="picker.textTitle2" :textConfirm="picker.textConfirm" :textCancel="picker.textCancel"
      @cancel="handlePickerCancel" @confirm="handlePickerConfirm2">{{ item.num }}</awesome-picker>
    <awesome-picker ref="picker3" :data="picker.data3" :textTitle="picker.textTitle3" :textConfirm="picker.textConfirm"
      :textCancel="picker.textCancel" @cancel="handlePickerCancel" @confirm="handlePickerConfirm3"></awesome-picker>
    <Rules v-if="showRules" @hide="showRules=false"/>
  </div>
</template>

<script>
import StatusBar from '../../components/StatusBar'
import Rules from './components/rules'
import { showToast, changeHistory, urlGet } from '../../utils/common'
import { getCityOpen, getSignUpInfo, updateBasic, checkInviteCode, submitInviteCode, getSwitch, checkStatus } from '../../utils/actions'
var signUpInfo = false
export default {
  name: 'SignUp',
  components: {
    StatusBar,
    Rules
  },
  data () {
    return {
      options: [],
      status: '',
      workCity: '工作地-城市',
      workCityId: '',
      workProvince: '工作地-省份',
      workType: '选择加盟司机类型',
      workTypeId: '',
      msgFrom: { value: '招募信息来源', index: '' },
      contactPhone: '',
      showConfirm: false,
      showRules: false,
      picker: {
        textTitle1: '请选择工作地省份',
        textTitle2: '请选择工作地城市',
        textTitle3: '请选择招募信息来源',
        textConfirm: '确定',
        textCancel: '取消',
        swipeTime: 1800,
        data1: [],
        data2: [],
        data3: []
      },
      inviteCode: '',
      isShowWorkType: false,
      defaultInfo: {
        default: '95139',
        default_text: '司机加盟咨询热线：'
      }
    }
  },
  cityConform: '',
  async created () {
    this.status = this.$route.params.status
    this.getOpenProvince()
    this.getMsgFrom()
    changeHistory()
    const query = urlGet()
    if (query.inviteCode) {
      this.inviteCode = query.inviteCode
    }
  },
  methods: {
    async getSwitchInfo () {
      let res = await getSwitch({
        city_id: this.workCityId,
        open_id: this.$store.state.openid
      })
      // res.work_type  0 精选 1 精选+轻享 -1 精选
      // res.is_franchise 1 仅精选 2精选/轻享 3仅轻享
      this.isShowWorkType = res.data.is_franchise === 2
      if (!this.isShowWorkType) {
        this.workTypeId = res.data.is_franchise === 1 ? 1 : 4
      }
    },
    provincePickerClick () {
      this.workCity = '工作地-城市'
      this.$refs.picker1.show()
      this.options = []
      var that = this
      setTimeout(() => {
        that.options = [{ num: 1 }]
      }, 100)
    },
    cityPickerClick () {
      if (this.workProvince === '工作地-省份') {
        showToast('请先选择省份')
        return
      }
      this.$refs.picker2[0].show()
    },
    fromPickerClick () {
      if (this.picker.data3.length > 0) {
        this.$refs.picker3.show()
      }
    },

    handlePickerCancel (e) {
    },
    getOpenProvince () {
      var that = this
      getCityOpen({ type: 2 }).then(function (res) {
        that.picker.data1 = []
        for (var i = 0; i < res.provincelist.length; i++) {
          var province = {
            value: res.provincelist[i].name,
            id: res.provincelist[i].id
          }
          that.picker.data1.push(province)
        }
      })
    },
    getOpenCity (id) {
      this.picker.data2 = []
      if (!id || id === 999) {
        return
      }
      var that = this
      getCityOpen({ type: 0, province_id: id }).then(function (res) {
        var list = []
        for (var i = 0; i < res.citylist.length; i++) {
          var city = {
            value: res.citylist[i].city_name,
            id: res.citylist[i].city_id
          }
          list.push(city)
        }
        that.picker.data2 = list
      })
    },
    getMsgFrom () {
      var parm = {
        open_id: this.$store.state.openid,
        id: this.$store.state.id
      }
      var that = this
      getSignUpInfo(parm).then(function (res) {
        if (!res || !res.data) return
        var list = res.data.src_list
        signUpInfo = true
        for (var key in list) {
          if (key < 0) {
            break
          }
          var obj = {
            value: list[key]
          }
          that.picker.data3.push(obj)
        }
        if (that.inviteCode) {
          that.setInviteInfo()
        }
      })
    },
    setInviteInfo () {
      this.picker.data3.some((item, index) => {
        if (item.value === '司机推荐') {
          this.msgFrom.value = item.value
          this.msgFrom.index = index
          return true
        }
      })
    },
    handlePickerConfirm1 (e) {
      this.workProvince = e[0].value
      var info = this.picker.data1[e[0].index]
      this.workTypeId = ''
      this.workType = '选择加盟司机类型'
      this.getOpenCity(info ? info.id : 999)
    },
    handlePickerConfirm2 (e) {
      this.workCity = e[0].value
      this.workCityId = this.picker.data2[e[0].index].id
      this.$store.commit('CITYID', this.workCityId)
      // 轻享链接进来的，只能是轻享
      let urlParams = urlGet()
      if (urlParams.work && urlParams.work * 1 === 4) {
        this.workTypeId = 4
        this.workType = '轻享司机'
      } else {
        this.workTypeId = ''
        this.getSwitchInfo()
      }
    },
    handlePickerConfirm3 (e) {
      this.msgFrom.value = e[0].value
      this.msgFrom.index = e[0].index
    },
    handlePickerConfirm4 (val, name) {
      this.workTypeId = val
      this.workType = name
      if (this.workTypeId) {
        getSwitch({
          open_id: this.$store.state.openid,
          city_id: this.workCityId,
          driver_work_type: this.workTypeId
        }).then((res) => {
          this.$store.commit('WORKTYPE', this.workTypeId)
          this.$store.commit('NEEDEXAM', res.data.exam)
        })
      }
    },
    async nextBtnClick (notCheckInviteCode) {
      var that = this
      if (that.workProvince === '工作地-省份') {
        showToast('请选择工作地省份')
        return
      }
      if (that.workCity === '工作地-城市') {
        showToast('请选择工作地城市')
        return
      }
      if (that.isShowWorkType) {
        if (!this.workTypeId) {
          showToast('请选择加盟司机类型')
          return
        }
      }
      if (that.msgFrom.value === '招募信息来源') {
        showToast('请选择招募信息来源')
        return
      }
      if (!(/^[1][3456789]\d{9}$/).test(that.contactPhone)) {
        showToast('请输入正确的紧急联系人手机号码')
        return
      }
      if (that.msgFrom.value === '司机推荐' && !notCheckInviteCode && this.workTypeId !== 4) {
        if (that.inviteCode.length === 0) {
          that.$confirm.show({
            message: '推荐码未填写，继续提交吗？',
            confirmText: '继续',
            cancelText: '取消',
            cancelCallback: function () {
              that.$confirm.close()
            },
            confirmCallback: function () {
              that.nextBtnClick(true)
              that.$confirm.close()
            }
          })
          return
        }
        const checkResult = await that.checkInviteCode()
        if (checkResult.code * 1 === 0) {
          that.cityConform = checkResult.data.cityConform
          if (!checkResult.data.invitePeople || checkResult.data.invitePeople === 'null') {
            that.$confirm.show({
              message: '推荐码无效，继续提交吗？',
              confirmText: '继续',
              cancelText: '取消',
              cancelCallback: function () {
                that.$confirm.close()
              },
              confirmCallback: function () {
                that.nextBtnClick(true)
                that.$confirm.close()
              }
            })
          } else {
            that.$confirm.show({
              message: `当前推荐码关联的司机为<span style='color:#00A0E8;'>${checkResult.data.invitePeople.name}</span>，\n继续提交吗？`,
              confirmText: '继续',
              cancelText: '取消',
              cancelCallback: function () {
                that.$confirm.close()
              },
              confirmCallback: function () {
                if (!checkResult.data.cityConform) {
                  that.$confirm.close()
                  that.$confirm.show({
                    message: `您选择的城市与推荐人绑定的城市\n【<span style='color: #00A0E8;'>${checkResult.data.cityName}</span>】不符，继续提交吗？`,
                    confirmText: '继续',
                    cancelText: '取消',
                    cancelCallback: function () {
                      that.$confirm.close()
                    },
                    confirmCallback: function () {
                      that.nextBtnClick(true)
                      that.$confirm.close()
                    }
                  })
                } else {
                  that.$confirm.close()
                  that.nextBtnClick(true)
                }
              }
            })
          }
          return
        }
      }

      if (this.msgFrom.value === '司机推荐') {
        await this.submitInviteCode()
      }

      var param = {
        open_id: this.$store.state.openid,
        id: this.$store.state.id,
        mobile: this.$store.state.phone,
        city_id: this.workCityId,
        src_value: this.msgFrom.value,
        sign_up_info: signUpInfo,
        src: this.msgFrom.index,
        method: 'driver.signup.update_basic',
        address: this.workProvince + this.workCity,
        contact_phone: this.contactPhone
      }
      param.driver_work_type = this.workTypeId
      updateBasic(param).then(async function (res) {
        if (res && res.code === 0) {
          var result = await getSwitch({
            open_id: that.$store.state.openid,
            city_id: that.workCityId,
            driver_work_type: that.workTypeId
          })
          let res = await checkStatus({
            open_id: that.$store.state.openid
          })
          if (res.data) {
            that.$store.commit('ID', res.data.id) // id
            that.$store.commit('CITYID', res.data.city_id) // cityId
            that.$store.commit('IDCAR', res.data.id_card) // cardId
            that.$store.commit('PHONE', res.data.mobile) // phone
            that.$store.commit('CNAME', res.data.company_name) // 路考分公司
            that.$store.commit('CPHONE', res.data.company_phone) // 分公司电话
            that.$store.commit('WORKTYPE', res.data.driver_work_type) // 司机类型
          }
          if (result.data.exam) {
            that.$router.push({ name: 'recruitAnswer', params: { status: res.data.status } })
            return
          }
          that.$router.push({ name: 'cardIDUpLoad', params: { status: '5' } })
        }
      })
    },
    // 校验邀请码
    checkInviteCode () {
      return checkInviteCode({
        inviteCode: this.inviteCode,
        cityId: this.workCityId
      })
    },

    submitInviteCode () {
      return submitInviteCode({
        phone: this.$store.state.phone,
        boostOpenId: this.$store.state.openid,
        inviteCode: this.inviteCode,
        cityConform: this.cityConform
      })
    },
    inputBlurEvent () {
      window.scroll(0, 0)
    },
    cancelBtnAction () {
      this.showConfirm = false
    },
    sureBtnAction () {
      this.cancelBtnAction()
      this.nextBtnClick()
    },
    showConfirmBox () {
      if (!this.complete) {
        this.showConfirm = true
      } else {
        this.nextBtnClick()
      }
    }
  },
  computed: {
    complete () {
      if (this.workCity !== '工作地-城市' && this.workProvince !== '工作地-省份' && this.msgFrom.value !== '招募信息来源' && this.contactPhone.length === 11 && this.workTypeId) {
        return ''
      }
      return 'opactiy'
    }
  }
}
</script>
<style lang="scss" scoped>

.row-bg {
  margin: 1.18rem 0.5rem 0.8rem;
  font-size: 0.28rem;
  box-sizing: border-box;

  .row {
    margin: 0 0.46rem;
    height: 0.98rem;
    border-bottom: 1px solid #e8e9eb;

    p {
      height: 0.98rem;
      width: 100%;
      line-height: 1.3rem;
      color: #97989b;
      background: url("../../assets/triangle_open@2x.png") right 70% no-repeat;
      background-size: 0.12rem 0.08rem;
    }

    input {
      border: none;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      padding-left: 0;
      padding-top: 0.3rem;
      background-color: transparent;
    }

    .txt-color {
      color: #19191a !important;
    }
  }

  .join-title-bg {
    margin: 0 0.46rem;
    margin-top: 0.48rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.28rem;
    color: #19191A;

    >div {
      display: flex;
      align-items: center;
    }

    img {
      margin-right: 0.06rem;
      width: 0.24rem;
      height: 0.24rem;
    }
    span {
      font-size: 0.24rem;
    }
  }

  .row1 {
    position: relative;

    p {
      display: inline-block;
    }

    .r-province {
      width: 40%;
    }

    .r-city {
      position: absolute;
      right: 0;
      width: 50%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.margin-bottom1 {
  margin: 1.18rem 0.4rem 2.8rem !important;
}

.join-table-bg {
  margin: 0.36rem 0;
  border: 1px solid lightgray;

  .comparison-table {
    width: 100%;
    border-collapse: collapse;

    td {
      padding: 0.18rem 0.1rem;
      text-align: center;
      border: 1px solid white;
      font-size: 0.24rem;
      word-wrap: break-word; // 长文本换行
      vertical-align: middle;
    }

    tr:first-child td {
      padding: 0.22rem 0.1rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.26rem;
      color: #19191A;
      background: #F5F5F5; // 添加表头背景色
      z-index: 1;
    }

    tr:not(:first-child) td:first-child {
      background: #F5F5F5;
    }
    .selected {
      background: #E6F4FF !important;
    }
  }
  .join-select-bg {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .join-select-img {
    margin-right: 3px;
    width: 13px;
    height: 13px;
  }
}

.join-driver-next-btn {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #FFFFFF;
  box-sizing: border-box;
  padding: 0 0.4rem;

  .detail-margin-bottom {
    margin: 0.2rem 0;
  }
}

.next-btn {
  width: 6.4rem;
  margin-left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 0.3rem;
  height: 0.92rem;
  line-height: 0.92rem;
  color: #ffffff;
  border-radius: 0.04rem;
  background-image: linear-gradient(269deg, #3B414D 0%, #262A32 100%);
}

.next-btn-margin {
  margin-bottom: 0.4rem;
}
.notes {
  width: 80%;
  padding-left: 10%;
  padding-bottom: 50px;
  font-size: .24rem;
  color: #97989B;

  p {
    font-weight: bold;
    margin-bottom: .36rem;
  }

  ul {
    list-style-type: decimal;
    margin-left: .35rem;
    line-height: .36rem;
  }
}

.opactiy {
  opacity: 0.3;
}

.detail {
  width: 100%;
  text-align: center;
  font-size: 0.24rem;
  color: #97989b;
}

.detail-margin {
  margin-top: 0.2rem;
  margin-bottom: 1rem;
}

.confirm {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);

  .c-bg {
    position: absolute;
    top: 3rem;
    transform: translateX(-50%);
    width: 6.5rem;
    height: 4rem;
    left: 50%;
    background: #FFFFFF;
    box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.20);
    border-radius: 2px;

    .c-title {
      text-align: center;
      font-size: 0.32rem;
      color: #19191A;

      p {
        padding-top: 0.54rem;
      }
    }

    .c-content {
      font-size: 0.28rem;
      color: #19191A;
      margin-left: 1.12rem;
      margin-top: 0.4rem;
    }

    .c-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      font-size: 0.32rem;
      height: 1rem;
      box-sizing: border-box;
      text-align: center;
      border-top: 1px solid #E8E9EB;
      display: flex;

      p {
        flex: 1;
        height: 100%;
        line-height: 1rem;
      }

      .c-cancel {
        color: #646566;
      }

      .c-sure {
        border-left: 1px solid #E8E9EB;
      }
    }
  }
}

.tips {
  width: 100%;
  height: .8rem;
  text-align: center;
  font-size: .24rem;
  background-color: #ffffff;
  font-weight: 400;
  color: #19191A;
  line-height: .8rem;
  position: fixed;
  bottom: 0rem;

  span {
    color: #2A2AFF;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/sign-up/index.vue